// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Row$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as Icon$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/icons/Icon.bs.js";
import * as UserRoleConfig from "../../../../../../configs/UserRoleConfig.bs.js";
import * as WorkSpaceContext from "../../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as ConfirmationModal from "../../../../pricing-dashboard/view/components/components/sidebars/ConfirmationModal.bs.js";
import * as CustomerInfoSidebarTabs from "./CustomerInfoSidebarTabs.bs.js";

function CustomerInfoSideBarHeader(Props) {
  var tabs = Props.tabs;
  var activeCustomerInfoTab = Props.activeCustomerInfoTab;
  var changeCustomerInfoTab = Props.changeCustomerInfoTab;
  var isConsentUpdated = Props.isConsentUpdated;
  var isAllEditable = Props.isAllEditable;
  var setIsAllEditable = Props.setIsAllEditable;
  var closeCustomerInfoSidebar = Props.closeCustomerInfoSidebar;
  var match = WorkSpaceContext.useWorkSpace(undefined);
  var match$1 = React.useState(function () {
        return false;
      });
  var setChangeTab = match$1[1];
  var match$2 = React.useState(function () {
        return activeCustomerInfoTab;
      });
  var setCurrentTab = match$2[1];
  var currentTab = match$2[0];
  var changeTabCnfCb = function (param) {
    Curry._1(changeCustomerInfoTab, (function (param) {
            return currentTab;
          }));
    return Curry._1(setChangeTab, (function (param) {
                  return false;
                }));
  };
  var changeTabCancelCb = function (param) {
    Curry._1(setCurrentTab, (function (param) {
            return activeCustomerInfoTab;
          }));
    return Curry._1(setChangeTab, (function (param) {
                  return false;
                }));
  };
  return React.createElement("div", {
              className: "header"
            }, React.createElement(Row$Catalyst.make, {
                  children: null,
                  className: "title"
                }, React.createElement("div", undefined, "Customer Information"), React.createElement(Row$Catalyst.make, {
                      children: null,
                      className: "header-actions"
                    }, activeCustomerInfoTab ? null : React.createElement("button", {
                            className: "edit",
                            disabled: !UserRoleConfig.isUserAllowed(UserRoleConfig.customerInfoEditRoles, match.user_roles),
                            onClick: (function (param) {
                                return Curry._1(setIsAllEditable, (function (param) {
                                              return !isAllEditable;
                                            }));
                              })
                          }, React.createElement(Icon$Catalyst.EditIcon.make, {
                                fontSize: "Large"
                              })), React.createElement("p", {
                          onClick: (function (param) {
                              return Curry._1(closeCustomerInfoSidebar, undefined);
                            })
                        }, React.createElement(Icon$Catalyst.CloseIcon.make, {
                              fontSize: "Large"
                            })))), React.createElement("div", {
                  className: "tabs-list"
                }, $$Array.map((function (tab) {
                        return React.createElement("div", {
                                    className: "tab " + (
                                      tab === activeCustomerInfoTab ? "selected-tab" : ""
                                    ),
                                    onClick: (function (param) {
                                        if (isAllEditable || isConsentUpdated) {
                                          Curry._1(setCurrentTab, (function (param) {
                                                  return tab;
                                                }));
                                          return Curry._1(setChangeTab, (function (param) {
                                                        return true;
                                                      }));
                                        } else {
                                          return Curry._1(changeCustomerInfoTab, (function (param) {
                                                        return tab;
                                                      }));
                                        }
                                      })
                                  }, CustomerInfoSidebarTabs.toString(tab));
                      }), tabs)), React.createElement(ConfirmationModal.make, {
                  title: "Discard Changes",
                  isOpen: match$1[0],
                  onConfirmCb: changeTabCnfCb,
                  onCancelCb: changeTabCancelCb,
                  confirm_button_title: "Yes, Discard",
                  cancel_button_title: "No, Cancel",
                  children: React.createElement("div", undefined, "You are about to leave this section. All the changes will be lost. Are you sure you wish to switch?")
                }));
}

var make = CustomerInfoSideBarHeader;

export {
  make ,
  
}
/* react Not a pure module */
